<template>
  <div class="right-box2-main">
    <div class="statis-title">
      <img class="img1" src="@/assets/screen/zhifang.png" alt="" />
      <span>{{+type === 1?'收款统计':'出货统计'}}</span>
      <template v-if="allStatistics">
        <div v-if="+type === 1">本月收款标准：{{allStatistics.virtualReceivePayment}}，实际达标标准：{{allStatistics.actualReceivePayment}}({{allStatistics.receivePaymentPercen}}%)</div>
        <div v-if="+type === 2">本月出货标准：{{allStatistics.virtualShipmentCount}}，实际达标标准：{{allStatistics.actualShipmentCount}}({{allStatistics.shipmentCountPercen}}%)</div>
      </template>
    </div>
    <!-- <div class="date-type">
      <span :class="{'active': item.id === dateType}" @click="handleTabDate(item.id)" v-for="(item,index) in dayData" :key="index">{{item.name}}</span>
    </div> -->
    <echarts-vue :echart-data="echartData" echartName="echarts" height="310px" />
  </div>

</template>

<script>
import echartsVue from './echarts.vue'
import { timeForMat } from '@/utils/index'
import DataBoardApi from '@/api/dataBoard/DataBoard'
export default {
  components: { echartsVue },
  props: ['type', 'allStatistics', 'analysis'], //1 收款统计 2 出货统计
  data() {
    return {
      dateType: 4,
      dayData: [
        // { id: 1, name: '今天' }, { id: 2, name: '昨天' },
        { id: 3, name: '最近7天' }, { id: 4, name: '最近1个月' }
      ],
      startTime: '',
      endTime: '',
      echartsData: [],
      xData: [],
    }
  },
  created() {
    this.startTime = timeForMat('6')[0]
    this.endTime = timeForMat('6')[1]
    if (+this.type === 1) {
      // this.getReceive()

    } else if (+this.type === 2) {
      this.getShipment()
    }
  },
  watch: {
    analysis(val) {
      this.calcDate(val)
      this.getEcharts1(val)
    }
  },
  methods: {

    //出货统计
    getShipment() {
      let params = {
        startTime: this.startTime + ' 00:00:00',
        endTime: this.endTime + ' 23:59:59',
        timeType: 1
      }
      DataBoardApi.shipmentAnalysisK(params).then(({ data }) => {
        if (data.length > 0) {
          this.calcDate(data)
          this.getEcharts(data)
        }
      })
    },
    //收款统计
    getReceive() {
      // let params = {
      //   startTime: this.startTime + ' 00:00:00',
      //   endTime: this.endTime + ' 23:59:59',
      //   timeType: 1
      // }
      // DataBoardApi.payStatistics(params).then(({ data }) => {
      //   if (data.length > 0) {
      //     this.calcDate(data)
      //     this.getEcharts1(data)
      //   }
      // })
    },
    calcDate(data) {
      let dateList = []
      data.forEach(item => {
        item.date = item.startTime.substr(0, 10).replace(/\-/g, "/")
      });
      dateList = data.map(item => item.date)
      this.xData = dateList
    },
    handleTabDate(type) {
      if (this.dateType === type) return
      this.dateType = type;
      // if (type === 1) {
      //   this.startTime = timeForMat('0')[0]
      //   this.endTime = timeForMat('0')[0]
      // } else if (type === 2) {
      //   this.startTime = timeForMat('1')[0]
      //   this.endTime = timeForMat('1')[0]
      // } else 
      if (type === 3) {
        this.startTime = timeForMat('6')[0]
        this.endTime = timeForMat('6')[1]
      } else if (type === 4) {
        this.startTime = timeForMat('29')[0]
        this.endTime = timeForMat('29')[1]
      }
      if (+this.type === 1) {
        this.getReceive()
      } else if (+this.type === 2) {
        this.getShipment()
      }
    },
    getEcharts(echartsData) {
      this.echartsData = this.synthesisSeriesData(echartsData, [
        { name: "当前", color: "#1596CD", key: "cou" },
        { name: "环比", color: "#EFDB1C", key: "huanBiCou" },
        { name: "同比", color: "#33AD47", key: "tongBiCou" },
      ], "line")
    },
    getEcharts1(echartsData) {
      this.echartsData = this.synthesisSeriesData(echartsData, [
        { name: "当前", color: "#1596CD", key: "money" },
        { name: "环比", color: "#EFDB1C", key: "huanBiMoney" },
        { name: "同比", color: "#33AD47", key: "tongBiMoney" },
      ], "line")
    },
    //合成图标Y轴信息
    synthesisSeriesData(datalist, ydata, chartType) {
      let param = {}, itemStyle = {};
      if (chartType === 'line') {
        param = { type: "line", smooth: true, symbolSize: 0 };
      } else if (chartType === 'bar') {
        itemStyle = { borderRadius: [30, 30, 0, 0] }
        param = { type: "bar", barWidth: "10%", barCategoryGap: "30%" };
      }
      return ydata.map(item => {
        return {
          name: item.name, ...param, data: datalist.map(it => it[item.key]), itemStyle: {
            ...itemStyle,
            color: item.color
          }
        }
      })
    }
  },
  computed: {
    echartData() {
      return {
        // legendData: item.dataList.map(it => it.title),
        xAxisData: this.xData,
        yAxisData: this.echartsData
      };
    },
  }
}
</script>
<style lang="scss" scoped>
@mixin wh($width, $height) {
  width: $width;
  height: $height;
}
@mixin fontColor($fonsSize, $color) {
  font-size: $fonsSize;
  color: $color;
}
.right-box2-main {
  .statis-title {
    display: flex;
    align-items: center;
    position: relative;
    margin-bottom: 10px;
    span {
      @include fontColor(16px, #fff);
      padding: 0 10px 0 8px;
    }
    .img1 {
      @include wh(24px, 24px);
    }
    .hint {
      @include wh(13px, 13px);
      cursor: pointer;
    }
    div {
      position: absolute;
      right: 0;
      @include fontColor(10px, #fff);
    }
  }
  .date-type {
    text-align: right;
    span {
      padding: 0 12px;
      @include fontColor(10px, #fff);
      cursor: pointer;
      &.active {
        background-color: #5a5a89;
        padding: 5px 10px;
        border-radius: 30px;
      }
    }
  }
}
</style>
